module.exports = __webpack_public_path__ + "img/Bootstrap_logo.0fbafbe7.svg";